import { CAMPAIGN_NAME_SEPARATOR, DEFAULT_POST_PRODUCTION_COMPANY_ID, DEFAULT_PRODUCTION_COMPANY_ID, MEDIA_COMPANY_NONE_ID } from './../../../utils/constants';
import dayjs from "dayjs";

export const mapCampaignDataForSubmitting = (campaignData: any) => {
    const campaignName = dayjs(campaignData.broadcastingDate).format('YYYY-MM') + ` ${CAMPAIGN_NAME_SEPARATOR} ` + campaignData.advertiser.shortName + (campaignData.brand.shortName !== campaignData.advertiser.shortName ? (` ${CAMPAIGN_NAME_SEPARATOR} ` + campaignData.brand.shortName) : '');
    // "No media company" (sentinel) persists as no FK (null); a real selection sends its client id.
    const mediaCompanyId = campaignData.mediaCompany?.value;
    const body = {
        Name: `${campaignName}${campaignData.name ? (' — ' + campaignData.name) : ''}`,
        IndustryId: campaignData.marketCategory.value,
        BroadcastingDate: campaignData.broadcastingDate,
        BrandId: campaignData.brand.value,
        AdvertiserId: campaignData.advertiser.value,
        PostProductionCompanyId: DEFAULT_POST_PRODUCTION_COMPANY_ID,
        // ProductionCompanyId: DEFAULT_PRODUCTION_COMPANY_ID,
        MediaCompanyId: mediaCompanyId === MEDIA_COMPANY_NONE_ID ? null : mediaCompanyId ?? null,
        AdvertisingAgencyId: campaignData.advertisingAgency.value,
        AdvertisingAgencyName: campaignData.advertisingAgency.label,
        ProjectType: "VideoAd",
        addToExist: String(campaignData?.addToExist || 0),
        campaignRetry: campaignData.campaignRetry,
    };

    return body;
};